// Translation dictionary for Gastromek CRM.
// Default language: German (de). Turkish (tr) kept as alternative.
// Access keys via dot notation, e.g. t("dashboard.title").
// Interpolation: t("products.syncSuccess", { count: 12 }).

export const translations = {
  de: {
    brand: { name: "Gastromek CRM", tagline: "Angebotsverwaltung" },
    common: {
      save: "Speichern",
      saving: "Wird gespeichert…",
      cancel: "Abbrechen",
      update: "Aktualisieren",
      delete: "Löschen",
      edit: "Bearbeiten",
      loading: "Wird geladen…",
      back: "Zurück",
      noResult: "Keine Ergebnisse",
      records: "Einträge",
      clear: "Leeren",
      yes: "Ja",
      no: "Nein",
    },
    lang: { de: "Deutsch", tr: "Türkisch", label: "Sprache" },
    nav: {
      dashboard: "Dashboard",
      customers: "Kunden",
      quotes: "Angebote",
      products: "Produkte",
      catalog: "Katalog",
      inventory: "Bestand",
      users: "Benutzer",
      settings: "Einstellungen",
      sectionMain: "Hauptmenü",
      sectionAdmin: "Verwaltung",
      logout: "Abmelden",
      roleAdmin: "Administrator",
      roleSales: "Vertriebsmitarbeiter",
      openMenu: "Menü öffnen",
      accounting: "Buchhaltung",
      roleAccounting: "Buchhaltung",
      projects: "Projekte",
    },
    login: {
      heroTitle: "Professionelle Angebotsverwaltung, zentral gesteuert.",
      heroSubtitle:
        "Erstellen Sie schnell professionelle Preisangebote für Ihre Kunden, laden Sie diese als PDF herunter und teilen Sie sie per WhatsApp oder E-Mail.",
      heroBadge: "Industrielle Küchenausstattung",
      welcome: "Willkommen",
      subtitle: "Melden Sie sich an, um auf das Panel zuzugreifen.",
      email: "E-Mail",
      password: "Passwort",
      submit: "Anmelden",
      failed: "Anmeldung fehlgeschlagen",
    },
    status: {
      taslak: "Entwurf",
      gonderildi: "Gesendet",
      kabul: "Angenommen",
      red: "Abgelehnt",
      suresi_doldu: "Abgelaufen",
    },
    table: {
      quoteNo: "Angebotsnr.",
      customer: "Kunde",
      preparedBy: "Erstellt von",
      date: "Datum",
      amount: "Betrag",
      status: "Status",
      validity: "Gültigkeit",
      registered: "Registriert",
      actions: "Aktion",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Überblick über den Angebotsstatus",
      newQuote: "Neues Angebot",
      customer: "Kunden",
      productFromFeed: "Produkte (aus Feed)",
      totalQuotes: "Angebote gesamt",
      recentQuotes: "Letzte Angebote",
      viewAll: "Alle anzeigen",
      noQuotes: "Noch keine Angebote.",
      pipeline: "Angebots-Pipeline",
      total: "Gesamt",
      financeTitle: "Einnahmen & Ausgaben (6 Monate)",
    },
    customers: {
      title: "Kunden",
      subtitle: "Verwalten, suchen und filtern Sie Ihre Kunden",
      newCustomer: "Neuer Kunde",
      editCustomer: "Kunde bearbeiten",
      companyName: "Unternehmen / Firmenname",
      taxNumber: "Steuernr. / ID",
      taxOffice: "Finanzamt",
      contactPerson: "Ansprechpartner",
      phone: "Telefon",
      whatsapp: "WhatsApp (mit Ländervorwahl)",
      email: "E-Mail",
      city: "Stadt",
      country: "Land",
      address: "Adresse",
      notes: "Notizen",
      searchPlaceholder: "Nach Firma, Steuernr., Name, Telefon oder E-Mail suchen…",
      thCompany: "Firma",
      thTaxNo: "Steuernr.",
      thContact: "Ansprechpartner",
      thPhone: "Telefon",
      thCity: "Stadt",
      notFound: "Kein Kunde gefunden.",
      deleted: "Kunde gelöscht",
      updated: "Kunde aktualisiert",
      added: "Kunde hinzugefügt",
      confirmDelete: "Möchten Sie diesen Kunden wirklich löschen?",
      confirmDeleteWithQuotes:
        "Für diesen Kunden sind Angebote gespeichert. Möchten Sie ihn samt ALLER Angebote wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
      forceDeleteSuffix: " Trotzdem zusammen mit den Angeboten löschen?",
    },
    customerDetail: {
      backToCustomers: "Zurück zu Kunden",
      profileSubtitle: "Kundenprofil",
      taxNoLabel: "Steuernr.: ",
      quoteForCustomer: "Angebot für diesen Kunden",
      companyInfo: "Firmeninformationen",
      companyName: "Firmenname",
      quotes: "Angebote",
      updated: "Kundendaten aktualisiert",
      notFound: "Kein Kunde gefunden.",
    },
    products: {
      title: "Produkte",
      subtitleFeed: "Aus dem Feed abgerufene Produkte",
      lastUpdate: "Letzte Aktualisierung",
      unit: "Produkte",
      updateFeed: "Feed aktualisieren",
      updating: "Wird aktualisiert…",
      searchPlaceholder: "Nach Produktname, Code oder Marke suchen…",
      notFound: "Kein Produkt gefunden.",
      syncSuccess: "{count} Produkte synchronisiert",
      syncFailed: "Synchronisierung fehlgeschlagen",
    },
    quotes: {
      title: "Angebote",
      subtitle: "Alle von Ihnen erstellten Angebote",
      searchPlaceholder: "Angebotsnr., Kundenname, Steuernr. …",
      allStatuses: "Alle Status",
      preparedBy: "Erstellt von",
      allUsers: "Alle Benutzer",
      notFound: "Kein Angebot gefunden.",
    },
    accounting: {
      title: "Buchhaltung",
      subtitle: "Einnahmen und Ausgaben verwalten",
      newIncome: "Einnahme",
      newExpense: "Ausgabe",
      add: "Hinzufügen",
      edit: "Eintrag bearbeiten",
      kind: "Art",
      income: "Einnahme",
      expense: "Ausgabe",
      incomePlural: "Einnahmen",
      expensePlural: "Ausgaben",
      category: "Kategorie",
      selectCategory: "Kategorie wählen",
      amount: "Betrag (€)",
      description: "Beschreibung (optional)",
      descriptionPlaceholder: "Optionale Notiz…",
      date: "Datum",
      searchPlaceholder: "In Kategorie und Beschreibung suchen…",
      filterAll: "Alle",
      filterIncome: "Nur Einnahmen",
      filterExpense: "Nur Ausgaben",
      dateFrom: "Von",
      dateTo: "Bis",
      totalIncome: "Einnahmen gesamt",
      totalExpense: "Ausgaben gesamt",
      net: "Saldo",
      noRecords: "Keine Einträge.",
      added: "Eintrag hinzugefügt",
      updated: "Eintrag aktualisiert",
      deleted: "Eintrag gelöscht",
      confirmDelete: "Diesen Eintrag löschen?",
      chartTitle: "Einnahmen & Ausgaben",
      createdBy: "Erstellt von",
      person: "Person",
      allPersons: "Alle Personen",
      belongsTo: "Zugeordnet zu",
      selectPerson: "Person wählen",
      amountRequired: "Bitte einen gültigen Betrag eingeben",
      categoryRequired: "Bitte eine Kategorie wählen",
      incomeTypes: { proje: "Projekt", magaza_satisi: "Ladenverkauf", diger: "Sonstiges" },
      expenseTypes: { kira: "Miete", personel_maasi: "Personalgehalt", muhasebe: "Buchhaltung", konaklama: "Unterkunft", ulasim: "Transport", fatura: "Rechnung", yazilim: "Software", yemek: "Verpflegung", yakit: "Kraftstoff", diger: "Sonstiges" },
    },
    projects: {
      title: "Projekte",
      subtitle: "Projekte und ihre Finanzen verwalten",
      add: "Projekt hinzufügen",
      newProject: "Neues Projekt",
      edit: "Projekt bearbeiten",
      name: "Projektname",
      namePlaceholder: "z. B. Restaurant-Einrichtung",
      info: "Projektinformationen",
      infoPlaceholder: "Details zum Projekt…",
      amount: "Projektsumme",
      currency: "Währung",
      customer: "Kunde",
      selectCustomer: "Kunde wählen",
      searchCustomer: "Kunde suchen…",
      noCustomerFound: "Kein Kunde gefunden.",
      noProjects: "Noch keine Projekte.",
      created: "Projekt erstellt",
      updated: "Projekt aktualisiert",
      deleted: "Projekt gelöscht",
      confirmDelete: "Dieses Projekt und alle zugehörigen Einnahmen/Ausgaben löschen?",
      back: "Zurück zu Projekten",
      projectAmount: "Projektsumme",
      totalIncome: "Erhaltene Zahlungen",
      remainingReceivable: "Offene Forderung",
      totalExpense: "Ausgaben gesamt",
      expensePaid: "Bezahlt",
      expenseRemaining: "Offene Schuld",
      profit: "Gewinn",
      incomeSection: "Einnahmen",
      addIncome: "Einnahme hinzufügen",
      incomeAdded: "Einnahme hinzugefügt",
      noIncome: "Keine Einnahmen.",
      confirmDeleteIncome: "Diese Einnahme löschen?",
      expenseSection: "Ausgaben",
      addExpense: "Ausgabe hinzufügen",
      expenseName: "Ausgabenname",
      expenseNamePlaceholder: "z. B. Möbeltischler",
      totalDebt: "Gesamtschuld",
      initialPayment: "Erste Zahlung (optional)",
      paid: "Bezahlt",
      remaining: "Offen",
      paymentsCount: "Zahlungen",
      expenseAdded: "Ausgabe hinzugefügt",
      expenseUpdated: "Ausgabe aktualisiert",
      noExpense: "Keine Ausgaben.",
      confirmDeleteExpense: "Diese Ausgabe und ihre Zahlungen löschen?",
      viewPayments: "Zahlungen ansehen",
      payments: "Zahlungen",
      addPayment: "Zahlung hinzufügen",
      paymentDate: "Datum",
      paymentNote: "Notiz",
      receipts: "Belege",
      uploadReceipt: "Beleg hochladen",
      paymentAdded: "Zahlung hinzugefügt",
      noPayments: "Noch keine Zahlungen.",
      confirmDeletePayment: "Diese Zahlung löschen?",
      uploading: "Wird hochgeladen…",
      date: "Datum",
      fieldAmount: "Betrag",
      note: "Notiz",
      nameRequired: "Bitte einen Namen eingeben",
      amountRequired: "Bitte einen gültigen Betrag eingeben",
      customerRequired: "Bitte einen Kunden wählen",
    },
    quoteForm: {
      newQuote: "Neues Angebot",
      editQuote: "Angebot bearbeiten",
      subtitle: "Produkte durch Suche hinzufügen, alle Felder über das Stift-Symbol anpassen",
      customer: "Kunde",
      customerSearchPlaceholder: "Nach Firmenname oder Steuernr. suchen…",
      noCustomerResult: "Keine Ergebnisse. Sie können auf der Kundenseite neue hinzufügen.",
      items: "Angebotspositionen",
      addProduct: "Produkt hinzufügen",
      customItem: "Eigene Position",
      customItemDefault: "Eigene Position",
      productSearchPlaceholder: "Nach Produktname, Code oder GTIN suchen…",
      min2chars: "Mindestens 2 Zeichen eingeben",
      noItems: 'Noch keine Produkte hinzugefügt. Beginnen Sie mit "Produkt hinzufügen".',
      notesTitle: "Angebotsnotizen",
      notesPlaceholder: "Zahlungsbedingungen, Lieferzeit, Garantie usw.",
      settings: "Angebotseinstellungen",
      currency: "Währung",
      currencyTRY: "₺ Türkische Lira (TRY)",
      currencyUSD: "$ US-Dollar (USD)",
      currencyEUR: "€ Euro (EUR)",
      validUntil: "Gültig bis",
      discount: "Rabatt (%)",
      discountHint: "(auf den Gesamtbetrag inkl. MwSt.)",
      statusLabel: "Status",
      total: "Summe",
      subtotal: "Zwischensumme",
      grandTotal: "Gesamtbetrag",
      vatIncluded: "inkl. MwSt.",
      vat: "MwSt. (%)",
      vatHint: "(Mehrwertsteuer)",
      vatLine: "MwSt.",
      itemCode: "Code",
      itemDesc: "Beschreibung",
      itemQty: "Menge",
      itemUnitPrice: "Einzelpreis",
      itemDiscPct: "Rab. %",
      itemLineTotal: "Positionsbetrag",
      remove: "Entfernen",
      editPlaceholder: "bearbeiten",
      features: "Eigenschaften",
      addFeature: "Eigenschaft hinzufügen",
      featurePlaceholder: "z. B. Maße: 60×60×85 cm",
      imageUrl: "Bild-URL",
      noImage: "Kein Bild",
      uploadFromComputer: "Hochladen",
      uploading: "Lädt hoch…",
      imageUploaded: "Bild hochgeladen",
      done: "Fertig",
      selectCustomer: "Bitte Kunden auswählen",
      addAtLeastOne: "Bitte mindestens ein Produkt hinzufügen",
      quoteUpdated: "Angebot aktualisiert",
      quoteCreated: "Angebot erstellt",
    },
    quoteView: {
      backToQuotes: "Zurück zu Angeboten",
      quoteTitle: "Angebot {no}",
      preparedByLabel: "Erstellt von: ",
      downloadPdf: "PDF herunterladen",
      downloadPricelessPdf: "Ohne Preise herunterladen",
      pricelessSuffix: "ohne-Preise",
      langTurkish: "Türkisch",
      langGerman: "Deutsch",
      translateError: "Übersetzung fehlgeschlagen: ",
      print: "Drucken",
      sign: "Signieren",
      unsign: "Signatur entfernen",
      emailSend: "Per E-Mail senden",
      emailDialogTitle: "Angebot per E-Mail senden",
      recipientEmail: "Empfänger-E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      pdfAutoAttach: "Der PDF-Anhang wird automatisch hinzugefügt.",
      send: "Senden",
      whatsappSend: "Per WhatsApp senden",
      whatsappDialogTitle: "WhatsApp senden",
      numberLabel: "Nummer (mit Ländervorwahl)",
      whatsappHint:
        "Der Chat öffnet sich in WhatsApp Web/App. Ein Download-Link Ihres Angebots-PDFs wird automatisch ans Ende der Nachricht angehängt; der Kunde kann das PDF mit einem Klick öffnen.",
      openAndSend: "Öffnen und senden",
      newRevision: "Neue Revision",
      revisions: "Revisionen",
      emailSent: "E-Mail gesendet",
      statusUpdated: "Status aktualisiert",
      quoteDeleted: "Angebot gelöscht",
      confirmDelete: "Möchten Sie dieses Angebot wirklich löschen?",
      pdfError: "PDF konnte nicht erstellt werden: ",
      pdfTemplateNotFound: "PDF-Vorlage nicht gefunden",
      notFound: "Kein Angebot gefunden.",
      revisionCreated: "{no} erstellt",
      emailDefaultSubject: "{company} - Angebot {no}",
      emailDefaultBody:
        "Sehr geehrte/r {name},\n\nanbei finden Sie unser Angebot mit der Nummer {no}. Bei Fragen oder Anmerkungen stehen wir Ihnen gerne zur Verfügung.\n\nMit freundlichen Grüßen,\n{company}",
      whatsappDefault:
        "Hallo, wir haben Ihnen unser Angebot mit der Nummer {no} übermittelt. Wir wünschen Ihnen einen schönen Tag.",
      pdfFilePrefix: "Angebot",
    },
    pdf: {
      heading: "ANGEBOT",
      quoteNo: "Angebotsnr.:",
      date: "Datum:",
      validity: "Gültig bis:",
      toCustomer: "Kunde",
      companyInfo: "Firmeninformationen",
      tel: "Tel: ",
      email: "E-Mail: ",
      thImage: "Bild",
      thProduct: "Produkt",
      thQty: "Menge",
      thUnitPrice: "Einzelpreis",
      thDisc: "Rab.%",
      thAmount: "Betrag",
      subtotal: "Zwischensumme",
      vat: "MwSt.",
      discount: "Rabatt",
      grandTotal: "GESAMTBETRAG",
      vatIncluded: "INKL. MWST.",
      notes: "Notizen",
      bankInfo: "Bankverbindung",
      taxNoShort: "St-Nr.: ",
      hrbNoShort: "HRB-Nr.: ",
      validityFooter: "Dieses Angebot ist gültig bis {date}.",
    },
    users: {
      title: "Benutzer",
      subtitle: "Verwalten Sie Benutzer mit Panel-Zugang",
      newUser: "Neuer Benutzer",
      editUser: "Benutzer bearbeiten",
      fullName: "Vor- und Nachname",
      role: "Rolle",
      roleAdminOption: "Administrator (Admin)",
      roleSales: "Vertriebsmitarbeiter",
      roleAccountingOption: "Buchhaltungseinheit",
      password: "Passwort",
      passwordEditHint: "(leer lassen, um nicht zu ändern)",
      userUpdated: "Benutzer aktualisiert",
      userAdded: "Benutzer hinzugefügt",
      userDeleted: "Benutzer gelöscht",
      passwordRequired: "Passwort erforderlich",
      confirmDelete: "Möchten Sie diesen Benutzer wirklich löschen?",
    },
    settings: {
      title: "Einstellungen",
      subtitle: "Ihre Firmendaten und Versandeinstellungen",
      saved: "Einstellungen gespeichert",
      tabCompany: "Firma",
      tabBank: "Bank",
      tabSocial: "Soziale Medien",
      tabEmail: "E-Mail",
      tabQuote: "Angebots-Standardwerte",
      logoUrl: "Logo-URL",
      uploadLogo: "Logo hochladen",
      uploadImage: "Bild hochladen",
      imageUploaded: "Bild hochgeladen",
      businessName: "Firmenname",
      slogan: "Slogan",
      website: "Website",
      phone: "Telefon",
      email: "E-Mail",
      taxOffice: "Finanzamt",
      taxNumber: "Steuernummer",
      hrbNumber: "HRB-Nummer",
      address: "Adresse",
      authorizedPerson: "Verantwortliche Person (erscheint als Signatur im Angebots-PDF)",
      fullNamePlaceholder: "Vor- und Nachname",
      bankIntro:
        "Sie können bis zu 3 Bankkonten hinzufügen. Eingegebene Konten werden im unteren Bereich des Angebots-PDFs angezeigt. Leere Konten werden nicht angezeigt.",
      bank: "Bank",
      bankName: "Bankname",
      accountHolder: "Kontoinhaber",
      currency: "Währung",
      socialIntro:
        "Geben Sie die vollständigen URLs Ihrer Social-Media-Konten ein. Die eingegebenen Links werden im unteren Bereich des Angebots-PDFs angezeigt.",
      provider: "Anbieter",
      providerResend: "Resend (empfohlen · 3.000 E-Mails/Monat kostenlos)",
      providerSmtp: "Eigener SMTP-Server",
      resendHintPre: "Erstellen Sie für Resend ein kostenloses Konto unter ",
      resendHintPost: " und fügen Sie Ihren API-Schlüssel hier ein.",
      replyInfoTitle: "Antworten erreichen Sie:",
      replyInfoBody:
        "Bei gesendeten E-Mails wird der Reply-To-Header automatisch auf Ihre E-Mail-Adresse aus dem Tab \"Firma\" gesetzt; wenn der Kunde auf \"Antworten\" klickt, erhalten Sie die Antwort.",
      senderInfoTitle: "So machen Sie die Absenderadresse zu Ihrer eigenen Domain:",
      senderInfoBody:
        "Verifizieren Sie im Resend-Panel unter \"Domains\" Ihre eigene Domain (z. B. firma.de) und geben Sie dann unten im Feld \"Absender-E-Mail\" eine Adresse wie angebot@firma.de ein.",
      resendApiKey: "Resend API-Schlüssel",
      senderEmailVerified: "Absender-E-Mail (verifizierte Domain)",
      smtpHost: "SMTP-Server",
      port: "Port",
      smtpUser: "Benutzer",
      smtpPassword: "Passwort",
      senderEmail: "Absender-E-Mail",
      useStarttls: "STARTTLS verwenden",
      emailSignature: "E-Mail-Signatur (HTML unterstützt)",
      addImageToSignature: "Bild zur Signatur hinzufügen",
      imageUploadedToSignature: "Bild hochgeladen und zur Signatur hinzugefügt",
      signaturePlaceholder:
        "Beispiel:\n<b>Max Mustermann</b><br/>Vertriebsleiter<br/>Gastromek · +49 555 000 00 00<br/><a href=\"https://gastromek.de\">gastromek.de</a>",
      signatureHelp:
        "Diese Signatur wird automatisch am Ende jeder gesendeten Angebots-E-Mail hinzugefügt. HTML-Tags werden unterstützt. Mit \"Bild zur Signatur hinzufügen\" können Sie ein Logo/Banner hochladen.",
      openaiApiKey: "OpenAI API-Schlüssel (Übersetzung)",
      openaiApiKeyHelp:
        "Wird für die Angebots-PDF-Übersetzung (Deutsch/Türkisch) verwendet. Ihren Schlüssel finden Sie unter platform.openai.com. Er wird sicher gespeichert und nie im PDF angezeigt.",
      defaultValidity: "Standard-Gültigkeit (Tage)",
      defaultQuoteNotes: "Standard-Angebotsnotizen",
      defaultQuoteNotesPlaceholder: "Zahlungsbedingungen, Lieferzeit, Garantie…",
      tabAccess: "Zugriff",
      accessTitle: "Seitenzugriff",
      accessIntro: "Wählen Sie, welche Rollen die Buchhaltungsseite und das Finanzdiagramm im Dashboard sehen dürfen. Administratoren haben immer Zugriff.",
      accountingAccessLabel: "Buchhaltung sichtbar für",
      projectsAccessLabel: "Projekte sichtbar für",
      roleAdminLabel: "Administrator",
      roleSalesLabel: "Vertriebsmitarbeiter",
      roleAccountingLabel: "Buchhaltungseinheit",
      alwaysOn: "Immer aktiv",
      cltl: "₺ TRY",
    },
  },

  tr: {
    brand: { name: "Gastromek CRM", tagline: "Teklif Yönetimi" },
    common: {
      save: "Kaydet",
      saving: "Kaydediliyor…",
      cancel: "İptal",
      update: "Güncelle",
      delete: "Sil",
      edit: "Düzenle",
      loading: "Yükleniyor…",
      back: "Geri",
      noResult: "Sonuç yok",
      records: "kayıt",
      clear: "Temizle",
      yes: "Evet",
      no: "Hayır",
    },
    lang: { de: "Almanca", tr: "Türkçe", label: "Dil" },
    nav: {
      dashboard: "Kontrol Paneli",
      customers: "Müşteriler",
      quotes: "Teklifler",
      products: "Ürünler",
      catalog: "Katalog",
      inventory: "Envanter",
      users: "Kullanıcılar",
      settings: "Ayarlar",
      sectionMain: "Ana",
      sectionAdmin: "Yönetim",
      logout: "Çıkış Yap",
      roleAdmin: "Yönetici",
      roleSales: "Satış Temsilcisi",
      openMenu: "Menüyü aç",
      accounting: "Muhasebe",
      roleAccounting: "Muhasebe Birimi",
      projects: "Projeler",
    },
    login: {
      heroTitle: "Profesyonel teklif yönetimi, tek panelden.",
      heroSubtitle:
        "Müşterilerinize hızlıca profesyonel fiyat teklifleri hazırlayın, PDF olarak indirin, WhatsApp veya e-posta ile paylaşın.",
      heroBadge: "Endüstriyel Mutfak Ekipmanları",
      welcome: "Hoş geldiniz",
      subtitle: "Panele erişmek için hesabınıza giriş yapın.",
      email: "E-posta",
      password: "Şifre",
      submit: "Giriş Yap",
      failed: "Giriş başarısız",
    },
    status: {
      taslak: "Taslak",
      gonderildi: "Gönderildi",
      kabul: "Kabul",
      red: "Red",
      suresi_doldu: "Süresi Doldu",
    },
    table: {
      quoteNo: "Teklif No",
      customer: "Müşteri",
      preparedBy: "Hazırlayan",
      date: "Tarih",
      amount: "Tutar",
      status: "Durum",
      validity: "Geçerlilik",
      registered: "Kayıt",
      actions: "İşlem",
    },
    dashboard: {
      title: "Kontrol Paneli",
      subtitle: "Teklif durumuna genel bakış",
      newQuote: "Yeni Teklif",
      customer: "Müşteriler",
      productFromFeed: "Ürün (feed'den)",
      totalQuotes: "Toplam Teklif",
      recentQuotes: "Son Teklifler",
      viewAll: "Tümünü gör",
      noQuotes: "Henüz teklif yok.",
      pipeline: "Teklif Hattı",
      total: "Toplam",
      financeTitle: "Gelir & Gider (6 Ay)",
    },
    customers: {
      title: "Müşteriler",
      subtitle: "Müşterilerinizi yönetin, arayın ve filtreleyin",
      newCustomer: "Yeni Müşteri",
      editCustomer: "Müşteri Düzenle",
      companyName: "İşletme / Firma Adı",
      taxNumber: "Vergi No / TC",
      taxOffice: "Vergi Dairesi",
      contactPerson: "Yetkili Kişi",
      phone: "Telefon",
      whatsapp: "WhatsApp (ülke kodu ile)",
      email: "E-posta",
      city: "Şehir",
      country: "Ülke",
      address: "Adres",
      notes: "Notlar",
      searchPlaceholder: "Firma, vergi no, isim, telefon veya e-posta ile ara…",
      thCompany: "Firma",
      thTaxNo: "Vergi No",
      thContact: "Yetkili",
      thPhone: "Telefon",
      thCity: "Şehir",
      notFound: "Müşteri bulunamadı.",
      deleted: "Müşteri silindi",
      updated: "Müşteri güncellendi",
      added: "Müşteri eklendi",
      confirmDelete: "Bu müşteriyi silmek istediğinize emin misiniz?",
      confirmDeleteWithQuotes:
        "Bu müşterinin kayıtlı teklifleri var. TÜM teklifleri ile birlikte silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
      forceDeleteSuffix: " Yine de teklifleri ile birlikte silinsin mi?",
    },
    customerDetail: {
      backToCustomers: "Müşterilere dön",
      profileSubtitle: "Müşteri profili",
      taxNoLabel: "Vergi No: ",
      quoteForCustomer: "Bu Müşteri İçin Teklif",
      companyInfo: "Firma Bilgileri",
      companyName: "Firma Adı",
      quotes: "Teklifler",
      updated: "Müşteri bilgileri güncellendi",
      notFound: "Müşteri bulunamadı.",
    },
    products: {
      title: "Ürünler",
      subtitleFeed: "Feed'den çekilen ürünler",
      lastUpdate: "Son güncelleme",
      unit: "ürün",
      updateFeed: "Feed'i Güncelle",
      updating: "Güncelleniyor…",
      searchPlaceholder: "Ürün adı, kodu veya marka ile ara…",
      notFound: "Ürün bulunamadı.",
      syncSuccess: "{count} ürün senkronize edildi",
      syncFailed: "Senkronizasyon başarısız",
    },
    quotes: {
      title: "Teklifler",
      subtitle: "Hazırladığınız tüm teklifler",
      searchPlaceholder: "Teklif no, müşteri adı, vergi no…",
      allStatuses: "Tüm durumlar",
      preparedBy: "Hazırlayan",
      allUsers: "Tüm kullanıcılar",
      notFound: "Teklif bulunamadı.",
    },
    accounting: {
      title: "Muhasebe",
      subtitle: "Gelir ve giderleri yönetin",
      newIncome: "Gelir",
      newExpense: "Gider",
      add: "Ekle",
      edit: "Kaydı Düzenle",
      kind: "Tür",
      income: "Gelir",
      expense: "Gider",
      incomePlural: "Gelirler",
      expensePlural: "Giderler",
      category: "Kategori",
      selectCategory: "Kategori seçin",
      amount: "Tutar (€)",
      description: "Açıklama (opsiyonel)",
      descriptionPlaceholder: "Opsiyonel not…",
      date: "Tarih",
      searchPlaceholder: "Kategori ve açıklamada ara…",
      filterAll: "Tümü",
      filterIncome: "Sadece Gelirler",
      filterExpense: "Sadece Giderler",
      dateFrom: "Başlangıç",
      dateTo: "Bitiş",
      totalIncome: "Toplam Gelir",
      totalExpense: "Toplam Gider",
      net: "Bakiye",
      noRecords: "Kayıt yok.",
      added: "Kayıt eklendi",
      updated: "Kayıt güncellendi",
      deleted: "Kayıt silindi",
      confirmDelete: "Bu kaydı silmek istiyor musunuz?",
      chartTitle: "Gelir & Gider",
      createdBy: "Ekleyen",
      person: "Kişi",
      allPersons: "Tüm kişiler",
      belongsTo: "Ait olduğu kişi",
      selectPerson: "Kişi seçin",
      amountRequired: "Lütfen geçerli bir tutar girin",
      categoryRequired: "Lütfen kategori seçin",
      incomeTypes: { proje: "Proje", magaza_satisi: "Mağaza Satışı", diger: "Diğer" },
      expenseTypes: { kira: "Kira", personel_maasi: "Personel Maaşı", muhasebe: "Muhasebe", konaklama: "Konaklama", ulasim: "Ulaşım", fatura: "Fatura", yazilim: "Yazılım", yemek: "Yemek", yakit: "Yakıt", diger: "Diğer" },
    },
    projects: {
      title: "Projeler",
      subtitle: "Projeleri ve finanslarını yönetin",
      add: "Proje Ekle",
      newProject: "Yeni Proje",
      edit: "Projeyi Düzenle",
      name: "Proje İsmi",
      namePlaceholder: "örn. Restoran Kurulumu",
      info: "Proje Bilgisi",
      infoPlaceholder: "Proje ile ilgili detaylar…",
      amount: "Proje Bedeli",
      currency: "Para Birimi",
      customer: "Müşteri",
      selectCustomer: "Müşteri seçin",
      searchCustomer: "Müşteri ara…",
      noCustomerFound: "Müşteri bulunamadı.",
      noProjects: "Henüz proje yok.",
      created: "Proje oluşturuldu",
      updated: "Proje güncellendi",
      deleted: "Proje silindi",
      confirmDelete: "Bu proje ve ona bağlı tüm gelir/giderler silinsin mi?",
      back: "Projelere dön",
      projectAmount: "Proje Bedeli",
      totalIncome: "Alınan Ödemeler",
      remainingReceivable: "Kalan Alacak",
      totalExpense: "Toplam Gider",
      expensePaid: "Ödenen",
      expenseRemaining: "Kalan Borç",
      profit: "Kâr",
      incomeSection: "Gelirler",
      addIncome: "Gelir Ekle",
      incomeAdded: "Gelir eklendi",
      noIncome: "Gelir yok.",
      confirmDeleteIncome: "Bu geliri silmek istiyor musunuz?",
      expenseSection: "Giderler",
      addExpense: "Gider Ekle",
      expenseName: "Gider İsmi",
      expenseNamePlaceholder: "örn. Mobilyacı",
      totalDebt: "Toplam Borç",
      initialPayment: "İlk Ödeme (opsiyonel)",
      paid: "Ödenen",
      remaining: "Kalan",
      paymentsCount: "Ödeme",
      expenseAdded: "Gider eklendi",
      expenseUpdated: "Gider güncellendi",
      noExpense: "Gider yok.",
      confirmDeleteExpense: "Bu gider ve ödemeleri silinsin mi?",
      viewPayments: "Ödemeleri gör",
      payments: "Ödemeler",
      addPayment: "Ödeme Ekle",
      paymentDate: "Tarih",
      paymentNote: "Not",
      receipts: "Dekontlar",
      uploadReceipt: "Dekont yükle",
      paymentAdded: "Ödeme eklendi",
      noPayments: "Henüz ödeme yok.",
      confirmDeletePayment: "Bu ödemeyi silmek istiyor musunuz?",
      uploading: "Yükleniyor…",
      date: "Tarih",
      fieldAmount: "Tutar",
      note: "Not",
      nameRequired: "Lütfen bir isim girin",
      amountRequired: "Lütfen geçerli bir tutar girin",
      customerRequired: "Lütfen müşteri seçin",
    },
    quoteForm: {
      newQuote: "Yeni Teklif",
      editQuote: "Teklif Düzenle",
      subtitle: "Ürünleri arayarak ekleyin, tüm alanları kalem ikonu ile özelleştirin",
      customer: "Müşteri",
      customerSearchPlaceholder: "Firma adı veya vergi no ile ara…",
      noCustomerResult: "Sonuç yok. Müşteriler sayfasından yeni ekleyebilirsiniz.",
      items: "Teklif Kalemleri",
      addProduct: "Ürün Ekle",
      customItem: "Özel Kalem",
      customItemDefault: "Özel Kalem",
      productSearchPlaceholder: "Ürün adı, kodu veya GTIN ile ara…",
      min2chars: "En az 2 karakter yazın",
      noItems: 'Henüz ürün eklenmedi. "Ürün Ekle" ile başlayın.',
      notesTitle: "Teklif Notları",
      notesPlaceholder: "Ödeme koşulları, teslim süresi, garanti vb.",
      settings: "Teklif Ayarları",
      currency: "Para Birimi",
      currencyTRY: "₺ Türk Lirası (TRY)",
      currencyUSD: "$ Dolar (USD)",
      currencyEUR: "€ Euro (EUR)",
      validUntil: "Geçerlilik Tarihi",
      discount: "İskonto (%)",
      discountHint: "(KDV dahil toplam üzerinden)",
      statusLabel: "Durum",
      total: "Toplam",
      subtotal: "Ara Toplam",
      grandTotal: "Genel Toplam",
      vatIncluded: "KDV Dahil",
      vat: "KDV (%)",
      vatHint: "(Katma Değer Vergisi)",
      vatLine: "KDV",
      itemCode: "Kod",
      itemDesc: "Açıklama",
      itemQty: "Adet",
      itemUnitPrice: "Birim Fiyat",
      itemDiscPct: "İnd. %",
      itemLineTotal: "Kalem Tutar",
      remove: "Kaldır",
      editPlaceholder: "düzenle",
      features: "Özellikler",
      addFeature: "Özellik ekle",
      featurePlaceholder: "örn. Ölçü: 60×60×85 cm",
      imageUrl: "Görsel URL",
      noImage: "Görsel yok",
      uploadFromComputer: "Yükle",
      uploading: "Yükleniyor…",
      imageUploaded: "Görsel yüklendi",
      done: "Tamam",
      selectCustomer: "Müşteri seçiniz",
      addAtLeastOne: "En az bir ürün ekleyiniz",
      quoteUpdated: "Teklif güncellendi",
      quoteCreated: "Teklif oluşturuldu",
    },
    quoteView: {
      backToQuotes: "Tekliflere dön",
      quoteTitle: "Teklif {no}",
      preparedByLabel: "Hazırlayan: ",
      downloadPdf: "PDF İndir",
      downloadPricelessPdf: "Fiyatsız Olarak İndir",
      pricelessSuffix: "fiyatsiz",
      langTurkish: "Türkçe",
      langGerman: "Almanca",
      translateError: "Çeviri başarısız: ",
      print: "Yazdır",
      sign: "İmzala",
      unsign: "İmzayı Kaldır",
      emailSend: "E-posta ile Gönder",
      emailDialogTitle: "E-posta ile Teklif Gönder",
      recipientEmail: "Alıcı E-posta",
      subject: "Konu",
      message: "Mesaj",
      pdfAutoAttach: "PDF eki otomatik olarak eklenir.",
      send: "Gönder",
      whatsappSend: "WhatsApp'tan İlet",
      whatsappDialogTitle: "WhatsApp Gönder",
      numberLabel: "Numara (ülke kodu ile)",
      whatsappHint:
        "WhatsApp Web/uygulamasında sohbet açılır. Teklif PDF'inizin indirme bağlantısı mesajın sonuna otomatik eklenir; müşteri tek tıkla PDF'i açabilir.",
      openAndSend: "Aç ve Gönder",
      newRevision: "Yeni Revizyon",
      revisions: "Revizyonlar",
      emailSent: "E-posta gönderildi",
      statusUpdated: "Durum güncellendi",
      quoteDeleted: "Teklif silindi",
      confirmDelete: "Bu teklifi silmek istediğinize emin misiniz?",
      pdfError: "PDF oluşturulamadı: ",
      pdfTemplateNotFound: "PDF şablonu bulunamadı",
      notFound: "Teklif bulunamadı.",
      revisionCreated: "{no} oluşturuldu",
      emailDefaultSubject: "{company} - Teklif {no}",
      emailDefaultBody:
        "Sayın {name},\n\n{no} numaralı teklifimizi ekte bulabilirsiniz. İnceledikten sonra soru veya görüşleriniz olursa lütfen bize ulaşın.\n\nSaygılarımızla,\n{company}",
      whatsappDefault: "Merhaba, {no} numaralı teklifimizi ilettik. İyi günler dileriz.",
      pdfFilePrefix: "Teklif",
    },
    pdf: {
      heading: "TEKLİF",
      quoteNo: "Teklif No:",
      date: "Tarih:",
      validity: "Geçerlilik:",
      toCustomer: "Sayın Müşteri",
      companyInfo: "Firma Bilgileri",
      tel: "Tel: ",
      email: "E-posta: ",
      thImage: "Görsel",
      thProduct: "Ürün",
      thQty: "Adet",
      thUnitPrice: "Birim Fiyat",
      thDisc: "İnd.%",
      thAmount: "Tutar",
      subtotal: "Ara Toplam",
      vat: "KDV",
      discount: "İskonto",
      grandTotal: "GENEL TOPLAM",
      vatIncluded: "KDV DAHİL",
      notes: "Notlar",
      bankInfo: "Banka Hesap Bilgileri",
      taxNoShort: "VN: ",
      hrbNoShort: "HRB No: ",
      validityFooter: "Bu teklif {date} tarihine kadar geçerlidir.",
    },
    users: {
      title: "Kullanıcılar",
      subtitle: "Panel erişimi olan kullanıcıları yönetin",
      newUser: "Yeni Kullanıcı",
      editUser: "Kullanıcıyı Düzenle",
      fullName: "Ad Soyad",
      role: "Rol",
      roleAdminOption: "Yönetici (Admin)",
      roleSales: "Satış Temsilcisi",
      roleAccountingOption: "Muhasebe Birimi",
      password: "Şifre",
      passwordEditHint: "(değiştirmeyecekseniz boş bırakın)",
      userUpdated: "Kullanıcı güncellendi",
      userAdded: "Kullanıcı eklendi",
      userDeleted: "Kullanıcı silindi",
      passwordRequired: "Şifre gerekli",
      confirmDelete: "Bu kullanıcıyı silmek istediğinize emin misiniz?",
    },
    settings: {
      title: "Ayarlar",
      subtitle: "Firma bilgileriniz ve gönderim tercihleri",
      saved: "Ayarlar kaydedildi",
      tabCompany: "Firma",
      tabBank: "Banka",
      tabSocial: "Sosyal Medya",
      tabEmail: "E-posta",
      tabQuote: "Teklif Varsayılanları",
      logoUrl: "Logo URL",
      uploadLogo: "Logo Yükle",
      uploadImage: "Görsel Yükle",
      imageUploaded: "Görsel yüklendi",
      businessName: "İşletme Adı",
      slogan: "Slogan",
      website: "Website",
      phone: "Telefon",
      email: "E-posta",
      taxOffice: "Vergi Dairesi",
      taxNumber: "Vergi Numarası",
      hrbNumber: "HRB Numarası",
      address: "Adres",
      authorizedPerson: "Yetkili Kişi (Teklif PDF'inde imza olarak görünecek)",
      fullNamePlaceholder: "Ad Soyad",
      bankIntro:
        "En fazla 3 banka hesabı ekleyebilirsiniz. Girilen hesaplar teklif PDF'inin alt kısmında gösterilir. Boş bıraktığınız hesaplar görünmez.",
      bank: "Banka",
      bankName: "Banka Adı",
      accountHolder: "Hesap Sahibi",
      currency: "Para Birimi",
      socialIntro:
        "Sosyal medya hesaplarınızın tam URL'lerini girin. Girilen bağlantılar teklif PDF'inin alt kısmında gösterilir.",
      provider: "Sağlayıcı",
      providerResend: "Resend (Önerilen · 3.000 e-posta/ay ücretsiz)",
      providerSmtp: "Kendi SMTP sunucum",
      resendHintPre: "Resend için ",
      resendHintPost: " üzerinden ücretsiz hesap açın, API anahtarınızı buraya yapıştırın.",
      replyInfoTitle: "Yanıtlar size gelsin:",
      replyInfoBody:
        "Gönderilen e-postalarda Reply-To başlığı otomatik olarak Firma sekmesindeki e-posta adresinize ayarlanır; müşteri \"Yanıtla\" dediğinde cevabı siz alırsınız.",
      senderInfoTitle: "Gönderen adresini kendi alan adınız yapmak için:",
      senderInfoBody:
        "Resend panelinde Domains bölümünden kendi domaininizi (ör. firma.com) doğrulayın, sonra aşağıdaki \"Gönderen E-posta\" alanına teklif@firma.com gibi bir adres yazın.",
      resendApiKey: "Resend API Anahtarı",
      senderEmailVerified: "Gönderen E-posta (doğrulanmış domain)",
      smtpHost: "SMTP Sunucu",
      port: "Port",
      smtpUser: "Kullanıcı",
      smtpPassword: "Şifre",
      senderEmail: "Gönderen E-posta",
      useStarttls: "STARTTLS kullan",
      emailSignature: "E-posta İmzası (HTML destekli)",
      addImageToSignature: "İmzaya Görsel Ekle",
      imageUploadedToSignature: "Görsel yüklendi ve imzaya eklendi",
      signaturePlaceholder:
        'Örnek:\n<b>Murat Yılmaz</b><br/>Satış Müdürü<br/>Gastromek · +90 555 000 00 00<br/><a href="https://gastromek.com">gastromek.com</a>',
      signatureHelp:
        "Gönderilen her teklif e-postasının sonuna bu imza otomatik olarak eklenir. HTML etiketleri desteklenir. \"İmzaya Görsel Ekle\" ile logo/banner yükleyebilirsiniz.",
      openaiApiKey: "OpenAI API Anahtarı (Çeviri)",
      openaiApiKeyHelp:
        "Teklif PDF'i çevirisi (Almanca/Türkçe) için kullanılır. Anahtarınızı platform.openai.com adresinden alabilirsiniz. Güvenli şekilde saklanır ve PDF'te asla görünmez.",
      defaultValidity: "Varsayılan Geçerlilik (gün)",
      defaultQuoteNotes: "Varsayılan Teklif Notları",
      defaultQuoteNotesPlaceholder: "Ödeme koşulları, teslimat süresi, garanti…",
      tabAccess: "Erişim",
      accessTitle: "Sayfa Erişimi",
      accessIntro: "Muhasebe sayfasını ve kontrol panelindeki finans grafiğini hangi rollerin görebileceğini seçin. Yöneticiler her zaman erişebilir.",
      accountingAccessLabel: "Muhasebe sayfasını görebilenler",
      projectsAccessLabel: "Projeler sayfasını görebilenler",
      roleAdminLabel: "Yönetici",
      roleSalesLabel: "Satış Temsilcisi",
      roleAccountingLabel: "Muhasebe Birimi",
      alwaysOn: "Her zaman açık",
      cltl: "₺ TL",
    },
  },
};
